<div class="content-mask-container">
  <div class="content-mask" *ngIf="loading">
    <ab-spinner></ab-spinner>
  </div>
  <div class="ab-chart">
    <ab-stacked-bar-chart
      class="ab-chart__chart"
      [config]="chartData"
    ></ab-stacked-bar-chart>
  </div>
</div>
